import React from 'react';
import { PropTypes } from 'prop-types';
// styles
import styled from 'styled-components';
// state
import { useSoFormStepsApi, useSoFormStepsState } from '../../SoForm.context';
// components
import SoFormButton from '../../components/other/SoFormButton';
import SoFormContainer from '../../components/layout/SoFormContainer';
import { ChevronRightIcon } from 'refactored/ui/icons';
import LoadSpinner from 'components/LoadSpinner';
import { useTranslation } from 'react-i18next';

const SoFormStepConfirmationFooter = ({ className }) => {
  const { t } = useTranslation('Catalog');

  const stepsApi = useSoFormStepsApi();
  const stepsState = useSoFormStepsState();

  const isLoading = stepsState.confirmation.isLoading;
  const selectedProductType = stepsState.price.selectedProductType;
  const candidates = stepsState.price.candidates;
  const selectedCandidate = candidates.find(
    (c) => c.productType === selectedProductType
  );
  const isRFQ = selectedCandidate.pricing_strategy !== 'INSTANT';
  const continueText = isRFQ
    ? t('confirmation.request_price')
    : t('confirmation.confirm_order');

  return (
    <div className={className}>
      <SoFormContainer>
        <SoFormButton inverse={true} onClick={stepsApi.onConfirmationGoBack}>
          {t('confirmation.edit_order')}
        </SoFormButton>
        <SoFormButton
          disabled={isLoading}
          onClick={stepsApi.onConfirmationSubmit}
        >
          {!isLoading && (
            <>
              {continueText} <ChevronRightIcon />
            </>
          )}
          {isLoading && <LoadSpinner />}
        </SoFormButton>
      </SoFormContainer>
    </div>
  );
};

SoFormStepConfirmationFooter.propTypes = {
  className: PropTypes.string,
};

export default styled(SoFormStepConfirmationFooter)`
  width: 100%;
  padding: 0px;
  padding-bottom: 16px;
  padding-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  justify-content: center;
  & > ${SoFormContainer} {
    gap: 10px;
    ${SoFormButton} {
      max-width: 50%;
    }
  }
`;
